// In local development, default to localhost
// For production builds (including mobile apps), use the production backend URL
// This can still be overridden by setting the environment variable `REACT_APP_API_BASE`.
export const API_BASE = process.env.REACT_APP_API_BASE || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://nehainfotech-backend.onrender.com' 
    : 'http://localhost:8081');

